import * as React from "react";

import {
  Layout,
  MainContentWrapper
} from "src/core/shared/components/Layout";
import { PageProps } from "src/pages/Router/routes";
import ProductReplacementForm from "src/core/products/components/ProductReplacementForm/ProductReplacementForm";

/**
 * Create and execute a product replacement
 */
export const CreateProductReplacementPage: React.ReactFCWithChildren<PageProps<unknown>> = props => {
  return (
    <Layout
      {...props}
      title="Product Replacement"
    >
      <MainContentWrapper fill>
        <ProductReplacementForm />
      </MainContentWrapper>
    </Layout>
  );
};
